









import { Component, Vue, Prop } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';

import SiteModule from '@/store/site';

@Component({
    components: {
        Loading,
    },
})
export default class BtnSubmit extends Vue {
    @Prop({ required: true }) readonly classAdd?: string;
    @Prop({ default: 'submit' }) readonly type?: string;

    get isLoading() {
        return SiteModule.isBlock;
    }

    get classes() {
        const classIsLoading = this.isLoading === true ? 'loading' : '';

        return `${classIsLoading} ${this.classAdd}`;
    }

    action() {
        this.$emit('click');
    }
}
